module.exports = __webpack_public_path__ + "static/img/file_zip.218bff27.png";